import { render, staticRenderFns } from "./inspectionDetail.vue?vue&type=template&id=6d1946d8&"
import script from "./inspectionDetail.vue?vue&type=script&lang=js&"
export * from "./inspectionDetail.vue?vue&type=script&lang=js&"
import style0 from "./inspectionDetail.vue?vue&type=style&index=0&id=6d1946d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports